// Ouverture de l'accueil ROOK (piste B2.2, 12/10/2026) : ajuste PRE-WORKOUT et la signature à la largeur disponible.
const hero = document.querySelector('.rok-hh');
if (hero) {
  const word = hero.querySelector('.rok-hh-word'), title = hero.querySelector('.rok-hh-title');
  // Réduit un texte trop large sans dépasser sa taille CSS
  function fit(el, maxW) {
    if (!el) return;
    el.style.fontSize = '';
    const w = el.scrollWidth, base = parseFloat(getComputedStyle(el).fontSize);
    if (w > maxW) el.style.fontSize = Math.floor(base * maxW / w) + 'px';
  }
  function fitTexts() {
    const vw = document.documentElement.clientWidth, small = vw <= 900;
    const left = word.getBoundingClientRect().left - hero.getBoundingClientRect().left;
    // Ordinateur : le mot reste dans les deux tiers gauches ; téléphone : marge de 16 px de chaque côté
    const maxW = small ? vw - left - 16 : vw * .66 - left;
    fit(word.firstElementChild, maxW);
    fit(title, maxW);
  }
  new ResizeObserver(fitTexts).observe(hero);
  fitTexts();
  document.fonts?.ready.then(fitTexts);
}
